<script>
    import cards from '@/assets/cards'

    export default {
        fonctional: true,
        props: {
            slug: {type: String, required: true}
        },
        render (__el) {
            let component
            switch (this.slug) {
                case 'the-ascender': component = cards.TheAscender; break;
                case 'the-bold': component = cards.TheBold; break;
                case 'the-cedilla': component = cards.TheCedilla; break;
                case 'the-descender': component = cards.TheDescender; break;
                case 'the-emdash': component = cards.TheEmdash; break;
                case 'the-font': component = cards.TheFont; break;
                case 'the-glyph': component = cards.TheGlyph; break;
                case 'the-hinting': component = cards.TheHinting; break;
                case 'the-italic': component = cards.TheItalic; break;
                case 'justify': component = cards.Justify; break;
                case 'the-kerning': component = cards.TheKerning; break;
                case 'the-lowercase': component = cards.TheLowercase; break;
                case 'the-masters': component = cards.TheMasters; break;
                case 'the-newfont': component = cards.TheNewfont; break;
                case 'the-point': component = cards.ThePoint; break;
                case 'the-opentype': component = cards.TheOpentype; break;
                case 'the-quotemark': component = cards.TheQuotemark; break;
                case 'the-revival': component = cards.TheRevival; break;
                case 'the-sans': component = cards.TheSans; break;
                case 'the-type-designer': component = cards.TheTypeDesigner; break;
                case 'the-uppercase': component = cards.TheUppercase; break;
                case 'the-other-ones': component = cards.TheOtherOnes; break;
                case 'verso': component = cards.Verso; break;
                default: console.error('"' + this.slug + '" is not a registered card.');
            }

            return __el(component)
        }
    }
</script>